import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class CacheService {
  private cache = new Map<string, { value$: Observable<any>; expiry: number }>();
  private scopedKeys = new Map<string, Set<string>>();

  getOrSet<T>(key: string, loader: () => Observable<T>, ttl: number = 5 * 60 * 1000, scopeId?: string): Observable<T> {
    const now = Date.now();
    const cached = this.cache.get(key);

    if (cached && now < cached.expiry) {
      return cached.value$;
    }

    const value$ = loader().pipe(shareReplay(1));
    this.cache.set(key, { value$, expiry: now + ttl });

    // Track scoped keys if scopeId provided
    if (scopeId) {
      if (!this.scopedKeys.has(scopeId)) {
        this.scopedKeys.set(scopeId, new Set());
      }
      this.scopedKeys.get(scopeId)?.add(key);
    }

    return value$;
  }

  invalidate(key: string): void {
    this.cache.delete(key);
  }

  clearScope(scopeId: string): void {
    const keys = this.scopedKeys.get(scopeId);
    if (keys) {
      keys.forEach((key) => this.cache.delete(key));
      this.scopedKeys.delete(scopeId);
    }
  }

  clearAll(): void {
    this.cache.clear();
    this.scopedKeys.clear();
  }
}
